import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as KleidungActions from "../../redux/Arbeitskleidung/actions";
import { Input, Button, DatePicker, Table, Row, Col, Radio, Divider, Modal, Dropdown, Menu, Card } from 'antd';
import Box from '../../components/utility/box';
import Header from '../../components/utility/pageHeader';
import LayoutWrapper from '../../components/utility/layoutWrapper';
import { history } from '../../redux/store';
import ArbeitskleidungDetailModal from '../../components/ArbeitskleidungDetailModal';
import './list.style.css';
import KleidungReducer from "../../redux/Arbeitskleidung/reducer";
import {EditOutlined} from "@ant-design/icons";

const { RangePicker } = DatePicker;
const RadioGroup = Radio.Group;


const Search = Input.Search;
const itemStyle = {margin: '0px'};





class Arbeitskleidung extends Component {



    componentWillMount() {
        this.props.actions.LoadArbeitskleidungen();
    }



    componentWillUpdate(nextProps) {
        if(this.props.KleidungModalVisible && !nextProps.KleidungModalVisible &&
            this.props.loadingKleidungList && !nextProps.loadingKleidungList) {
            this.props.actions.LoadArbeitskleidungen();
        }
    }




    render() {


        return (
            <React.Fragment>
                <ArbeitskleidungDetailModal />
                <LayoutWrapper>
                    <Row gutter={16} style={{width: '100%'}}>

                    {this.props.KleidungList.map(kleidung =>
                        <Col span={6}>
                            <Card title={<span><span>{kleidung.Group}</span>{this.props.isAdmin ? <a onClick={() =>this.props.actions.showArbeitskleidungModal(true, kleidung.GroupID)} style={{float: 'right'}}><EditOutlined /></a> : ''}</span>} bordered={false} style={{ width: 300 }}>
                                <ul>
                                {kleidung.Kleidung.map(kl =>
                                {
                                    if(kl) {
                                        return <li>{kl}</li>
                                    }
                                }
                                )}
                                </ul>
                            </Card>
                        </Col>
                    )}
                    </Row>
                </LayoutWrapper>
            </React.Fragment>
        );
    }
}


function mapStateToProps(state) {
    const { KleidungReducer, Auth } = state;
    const { KleidungList, loadingKleidungList, KleidungModalVisible } = KleidungReducer;
    const {isAdmin} = Auth;

    return {
        KleidungList,
        loadingKleidungList,
        KleidungModalVisible,
        isAdmin
    };
}


function mapDispatchToProps(dispatch) {
    return{
        actions: bindActionCreators(KleidungActions, dispatch)
    };
}



export default connect(mapStateToProps, mapDispatchToProps)(Arbeitskleidung);
